import * as React from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from 'styled-components';
import ScrollToTop from 'react-scroll-up';

import Nav from './nav';
import Footer from './footer';
import Contact from "./sections/contact"
import Icon  from '../icons/icon';


import { GlobalStyle, theme } from '../styles';

const Layout = ({ children}) => {
  
  return (
    <>
    <ThemeProvider theme={theme}>
     <GlobalStyle />
      <Nav/>
      
        <main>{children}</main>
        <Contact />
        <Footer/>

         <ScrollToTop
          showUnder={300}
          duration={700}
          easing="easeInOutCubic"
          style={{ bottom: 30, right: 20 }}
        >
          <span className="topIcon">
             <Icon  name='top'/>
          </span>
        </ScrollToTop>
     
      </ThemeProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout
